import { events, track, type PricesShownAtCheckoutArgs } from 'src/analytics';
import { reporter } from 'src/services/reporter';

interface TrackPricesShownAtCheckoutArgs {
  userId?: number;
  pricesShownAtCheckout: PricesShownAtCheckoutArgs;
}
export function trackPricesShownAtCheckout({
  userId,
  pricesShownAtCheckout,
}: TrackPricesShownAtCheckoutArgs) {
  if (!userId) {
    reporter.error(
      `Segment event "${events.checkout_prices_shown}" has missing parameter "userId"`,
      {
        pricesShownAtCheckout,
      }
    );
  }

  track(events.checkout_prices_shown, {
    userId,
    ...pricesShownAtCheckout,
  });
}
